export { default } from './withStyles';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/esm/withStyles/index.js
// module id = 916
// module chunks = 2